// frontend/src/components/ProductCard.jsx
import { Link } from "react-router-dom";
import { Heart, User } from "lucide-react";

const ProductCard = ({ post }) => {
  // Obtener la primera foto
  const getFirstPhoto = () => {
    if (!post.fotos) return "/placeholder-image.jpg";
    
    if (Array.isArray(post.fotos) && post.fotos.length > 0) {
      return post.fotos[0];
    }
    
    if (typeof post.fotos === "string") {
      try {
        const parsed = JSON.parse(post.fotos);
        if (Array.isArray(parsed) && parsed.length > 0) {
          return parsed[0];
        }
      } catch {
        return post.fotos || "/placeholder-image.jpg";
      }
    }
    
    return "/placeholder-image.jpg";
  };

  // Formatear precio
  const formatPrice = (price) => {
    if (!price && price !== 0) return "Grátis";
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(price);
  };

  // Obtener nombre del vendedor
  const getVendorName = () => {
    if (post.user?.apelido) return post.user.apelido;
    if (post.user?.name) return post.user.name;
    return null;
  };

  // Determinar si muestra "Novo" (hasta 4 horas)
  const isNew = () => {
    if (!post.created_at) return false;
    const now = new Date();
    const created = new Date(post.created_at);
    const diffHours = (now - created) / (1000 * 60 * 60);
    return diffHours < 4 && !post.is_sold;
  };

  const foto = getFirstPhoto();
  const linkTo = post.slug ? `/produto/${post.slug}` : `/produto/${post.id}`;
  const showNew = isNew();
  const vendorName = getVendorName();

  return (
    <Link to={linkTo} className="block group h-full">
      <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 border border-gray-100/80 hover:border-[#449879]/20 hover:-translate-y-1.5 flex flex-col h-full backdrop-blur-sm">
        {/* IMAGEN */}
        <div className="relative w-full bg-gray-50 flex-shrink-0 overflow-hidden" style={{ paddingBottom: '100%' }}>
          <div className="absolute inset-0 flex items-center justify-center">
            <img
              src={foto}
              alt={post.titulo}
              loading="lazy"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
              onError={(e) => {
                console.error("Error loading image:", foto);
                e.target.src = "/placeholder-image.jpg";
              }}
            />
          </div>
          
          <div className="absolute inset-0 bg-gradient-to-t from-black/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
          
          {/* 🔥 BADGES - SOLO DOAÇÃO Y NOVO (4 HORAS) */}
          <div className="absolute top-3 left-3 flex flex-col gap-1.5">
            {/* Badge "Doação" */}
            {post.tipo === "Doação" && (
              <span className="bg-gradient-to-r from-green-500 to-emerald-500 text-white text-[10px] font-semibold px-2.5 py-1 rounded-full flex items-center gap-1 shadow-lg shadow-green-500/25">
                <Heart className="w-3 h-3 fill-white" />
                Doação
              </span>
            )}
          </div>
          
          {/* 🔥 BADGE "NOVO" (4 HORAS) - ABAJO */}
          <div className="absolute bottom-2 left-2 flex flex-wrap gap-1.5">
            {showNew && (
              <span className="bg-[#449879]/90 text-white text-[9px] md:text-[10px] font-semibold px-2 py-0.5 rounded-full shadow-lg shadow-[#449879]/30 backdrop-blur-sm">
                ✨ Novo
              </span>
            )}
          </div>
          
          {/* Overlay de vendido */}
          {post.is_sold && (
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center">
              <span className="bg-red-500 text-white px-4 py-1.5 rounded-full text-sm font-bold tracking-wider shadow-lg shadow-red-500/30">
                VENDIDO
              </span>
            </div>
          )}
        </div>

        {/* Título y Precio con Apelido */}
        <div className="p-3 md:p-4 pt-2 md:pt-3 flex flex-col flex-1">
          <div className="min-h-[38px] md:min-h-[44px] flex items-start">
            <h3 className="font-semibold text-gray-800 text-xs md:text-base line-clamp-2 leading-snug group-hover:text-[#449879] transition-colors duration-300">
              {post.titulo}
            </h3>
          </div>

          <div className="mt-0.5 flex items-center justify-between">
            <p className="text-xs md:text-base font-bold text-[#449879] tracking-tight">
              {post.tipo === "Venda" ? formatPrice(post.preco) : "🎁 Grátis"}
            </p>
            
            {vendorName && (
              <div className="flex items-center gap-1 text-[10px] md:text-xs text-gray-400">
                <User className="w-3 h-3 md:w-3.5 md:h-3.5" />
                <span className="truncate max-w-[60px] md:max-w-[80px]">{vendorName}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;